import { Switch } from '@thanx/uikit/switch'
import { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import useFlag from 'hooks/useFlag'
import { buildTranslate } from 'locales'
import ModifierOrProductInput from 'scenes/RedeemManager/Builder/ConfigurationStep/ModifierOrProductInput'
import ModifierToggle from 'scenes/RedeemManager/Builder/ConfigurationStep/ModifierToggle'

import { type Fields } from 'models/CouponPool'

type ConditionalProductInputProps = {
  couponPool: Fields | null
  displayRequiredProducts: boolean
  requiredProductIds: string[]
  isFree?: boolean
  discountedProductIds: string[]
  discountedModifierIds?: string[]
  displayFreeModifiers?: boolean
}

const t = buildTranslate(
  'redeem_manager.builder.steps.configuration.instore_redemption_card.coupon_codes'
)

const ConditionalProductInput = ({
  couponPool,
  displayRequiredProducts,
  requiredProductIds,
  isFree,
  discountedProductIds,
  discountedModifierIds,
  displayFreeModifiers = false,
}: ConditionalProductInputProps) => {
  const hasDiscountedModifierIds = Boolean(
    Array.isArray(discountedModifierIds) && discountedModifierIds.length > 0
  )
  const [isModifierToggleVisible, setIsModifierToggleVisible] = useState(
    hasDiscountedModifierIds
  )
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)

  return (
    <>
      <Switch condition={Boolean(couponPool && displayRequiredProducts)}>
        <ModifierOrProductInput
          label={t('required_label_fallback')}
          name="instoreRequiredProductIds"
          className="mb-m"
          value={requiredProductIds}
          validations={{ isRequired: true }}
          validationErrors={{
            isRequired: I18n.t('validations.is_required'),
          }}
        />
      </Switch>
      <ModifierOrProductInput
        label={
          isFree
            ? t('discounted_free_item_title')
            : t('discounted_label_free_item')
        }
        secondaryText={isFree ? t('discounted_label_free_item') : undefined}
        name="instoreDiscountedProductIds"
        value={discountedProductIds}
        validations={{ isRequired: true }}
        validationErrors={{
          isRequired: I18n.t('validations.is_required'),
        }}
      />
      <p className="mt-xs body-text-4 grey-70">
        {isFree ? t('will_apply_lowest_free_item') : t('will_apply_lowest')}
      </p>
      <Switch condition={freeModifierRewardsEnabled}>
        <p className="mt-xs body-text-4 grey-70">{t('including_addons')}</p>
      </Switch>
      <Switch condition={Boolean(displayFreeModifiers)}>
        <ModifierToggle
          isVisible={isModifierToggleVisible}
          setIsVisible={setIsModifierToggleVisible}
        >
          <div className="mt-m">
            <ModifierOrProductInput
              label={t('discounted_free_item_modifier_title')}
              secondaryText={t('discounted_label_free_item_modifier')}
              tertiaryText={t('discounted_free_item_modifier_help_text')}
              name="instoreDiscountedModifierIds"
              toggleVisibility={setIsModifierToggleVisible}
              value={discountedModifierIds}
              shouldDisplayModifierPopover={true}
            />
          </div>
        </ModifierToggle>
      </Switch>
    </>
  )
}

export default ConditionalProductInput
